/**
 *
 */

import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinOutroController} from "@nolimitcity/slot-game/bin/game/screen/freespinoutro/FreespinOutroController";
import {DirtyWildsSoundConfig} from "../DirtyWildsSoundConfig";
import {DirtyWildGameMode} from "../features/DirtyWildsRespinZeroBetController";
import {DirtyWildsParsedGameData} from "../server/data/DirtyWildsParsedGameData";

export class DirtyWildsFreespinOutroController extends FreespinOutroController {

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected calculateIsTriggered(data:DirtyWildsParsedGameData):boolean {
        return data.mode === DirtyWildGameMode.STICKY_RESPIN && data.nextMode === DirtyWildGameMode.NORMAL && data.freespinsLeft === 0;
    }

    // Return false if it only does some restore/transition but no need to show. eg: restore in the middle of Freespin.
    protected show():boolean {
        if(this.shouldShow()) {
            this._view.show(this._serverData!, () => this.onShowComplete());
            this.hideKeypad();
            SlotGame.keypad.setZeroBetSpinCounter(-1);
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            this._isShowing = true;
        }

        // When restore in freespin, don't show the intro but we need the intro to init the freespin scene.
        if(this.doTransitions) {
            this.doTransitions();
        }

        return this._isShowing;
    }

    private playMainSound():void {
        SlotGame.sound.playAmbience(DirtyWildsSoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.fadeAmbience(1, 5000);
    }
}